var React = require('react');

function Y2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Y2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("polygon",{"points":"43.49 25.88 24.66 1.57 0 3.61 31.91 44.79 43.49 25.88","fill":"#e5c83d"})),React.createElement("polygon",{"points":"71.27 0 46.58 1.61 16.19 83.81 40.88 82.19 71.27 0","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Y2.defaultProps = {"viewBox":"0 0 71.27 83.81"};

module.exports = Y2;

Y2.default = Y2;
